import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { useFair } from '../../api/FairProvider';
import { paths } from '../../routes';
import { BellIcon, SearchIcon } from '../icons';

/** Fixed on every screen: brand mark home, search and news. There is no bottom
 *  navigation in the designs, so these two icons are the whole global nav. */
export function AppHeader(): ReactElement {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { fair } = useFair();
  const isHome = pathname === '/';

  return (
    <header className="relative z-20">
      <div className="app-shell flex items-center justify-between py-4">
        {/* Home shows the full lockup in its hero, so repeating the horizontal mark
            here would put the same logo on screen twice. The empty span keeps the
            icons pinned right. */}
        {isHome ? (
          <span />
        ) : (
          <Link to="/" aria-label={t('header.home')}>
            <img
              src={fair?.iconUrl ?? '/assets/logo-horizontal.svg'}
              alt={fair?.name ?? ''}
              className="h-8 w-auto"
            />
          </Link>
        )}

        <nav className="flex items-center gap-5">
          <Link
            to={paths.search}
            aria-label={t('header.search')}
            aria-current={pathname.startsWith(paths.search) ? 'page' : undefined}
            className="text-fog-100 transition-opacity hover:opacity-70"
          >
            <SearchIcon className="size-7" />
          </Link>
          <Link
            to={paths.news}
            aria-label={t('header.news')}
            aria-current={pathname.startsWith(paths.news) ? 'page' : undefined}
            className="text-fog-100 transition-opacity hover:opacity-70"
          >
            <BellIcon className="size-7" />
          </Link>
        </nav>
      </div>
    </header>
  );
}
